import i18next from "i18next";
import React from "react";
import { Flex, Text } from "rebass";
import { theme } from "src/styles/theme";
function createSchoolDegreeLabel(schoolDegrees) {
    return schoolDegrees
        .map(function (schoolDegree) { return schoolDegree.name; })
        .join(" ".concat(i18next.t("and"), " "));
}
var Notification = function (_a) {
    var notification = _a.notification;
    return (React.createElement(Flex, { alignItems: "center", justifyContent: "center", width: "2.2rem", bg: "secondary", color: "white", fontSize: "1.2rem", css: "\n      height: 2.2rem;\n      border-radius: 50%;\n      font-weight: ".concat(theme.fontWeights.semibold, ";\n    ") }, notification));
};
export var CollectionHeader = function (_a) {
    var schoolDegrees = _a.schoolDegrees, schoolSubjectName = _a.schoolSubjectName;
    return (React.createElement(Text, { as: "span", fontSize: "1.2rem" }, "".concat(createSchoolDegreeLabel(schoolDegrees), " - ").concat(schoolSubjectName)));
};
export var FolderHeader = function (_a) {
    var label = _a.label, notification = _a.notification, _b = _a.color, color = _b === void 0 ? theme.colors["others"] : _b;
    return (React.createElement(Flex, { alignItems: "center", justifyContent: "space-between", pb: "1rem" },
        React.createElement(Text, { as: "span", pb: ".4rem", color: color, fontSize: "1.2rem" }, label),
        !!notification && React.createElement(Notification, { notification: notification })));
};
